import { AppIntegrationsRepository, AppPricesRepository, ActivationCodesRepository } from 'common/repositories/index';
// import Util from 'common/services/util/-RFC.util';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const _directiveDependencies = [];
const _controllerDependencies = [
    '$scope', '$rootScope', '$state', '$window', 'Util', '$location', '$anchorScroll', 'AppPricesRestService', 'PaymentUrlsRestService', 'ErrorHandler',
];

class PrimePageController {

    constructor(
        $scope, $rootScope, $state, $window, Util, $location,
        $anchorScroll, AppPricesRestService, PaymentUrlsRestService, ErrorHandler,
    ) {

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$window = $window;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        const productsDetails = [];
        this.$scope.windowsProducts = [];
        this.$scope.osxProducts = [];
        this.$scope.androidProducts = [];
        this.$scope.iosProducts = [];
        this.AppPricesRestService = AppPricesRestService;
        this.PaymentUrlsRestService = PaymentUrlsRestService;
        this.ErrorHandler = ErrorHandler;
        this.$scope.price = '';
        this.$scope.products = AppIntegrationsRepository.getById('aps10');
        const productsIds = this.$scope.products.relationships.apps.data;
        this.$scope.AllPrices = AppPricesRepository.getAll();
        this.$scope.browsersExtensions = [];
        this.$scope.numberOfUsers = '1';
        this.$scope.runtime = '12';
        const browsersExtensions = ['pasm1', 'absn0', 'assh0'];
        this.Util = Util;
        this.navigator = Util.getDeviceNavigator();
        this.$scope.numberOfDevices = '5';

        this.$scope.activeProduct = 'aps10';
        this.$scope.product = AppIntegrationsRepository.getAppName('aps10');
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        this.$scope.language = CWCONFIG.language === 'de' ? 'de' : null;

        this.$rootScope.isPrimeStore = true;

        this.$scope.showOPCButton = false;
        this.$scope.isOneClickPaymentEnable = CWCONFIG.features.oneClickPayment;

        eventManager.subscribe('showRecommendation:true', () => {

            this.$scope.showOPCButton = true;

        });
        eventManager.subscribe('showRecommendation:false', () => {

            this.$scope.showOPCButton = false;

        });

        Mixpanel.send('ConnectWeb Store Open', {
            Source: 'Direct',
            Store: 'Prime Page',
        });

        const hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];
        if (productsIds) {

            productsIds.forEach((product) => {

                if (!hiddenAppInBundleIds.find(id => product.id === id)) {

                    productsDetails.push(AppIntegrationsRepository.getById(product.id));

                }

            });

        }

        // sort products by os
        productsDetails.forEach((product) => {

            const platform = product.attributes.custom.manifest.os;
            const isWindows = platform.find(os => os === 'windows');
            const isOsx = platform.find(os => os === 'osx');
            const isAndroid = platform.find(os => os === 'android');
            const isIos = platform.find(os => os === 'ios');

            if (isWindows) {

                this.$scope.windowsProducts.push(product);

            }
            if (isOsx) {

                this.$scope.osxProducts.push(product);

            }
            if (isAndroid) {

                this.$scope.androidProducts.push(product);

            }
            if (isIos) {

                this.$scope.iosProducts.push(product);

            }

        });

        // get browsers extensions
        browsersExtensions.forEach((product) => {

            this.$scope.browsersExtensions.push(AppIntegrationsRepository.getById(product));

        });

        const primeLicenses = this.checkPrimeActivationCodes();


        this.$scope.hasAps20 = primeLicenses
            .find(license => license.attributes.app === 'aps20');

        if (!this.$scope.hasAps20) {

            this.$scope.hasAps10 = primeLicenses
                .find(license => license.attributes.app === 'aps10');

        }


        if ($scope.hasAps20) {

            this.$scope.activeProduct = 'aps20';
            this.$scope.numberOfDevices = '25';

        }

        if ($scope.hasAps10) {

            this.$scope.activeProduct = 'aps10';
            this.$scope.numberOfDevices = '5';

        }

        this.groupPrices(this.$scope.AllPrices);

        this.$scope.$on('$destroy', () => {

            this.$rootScope.welcomeOffers = {};

        });

        //* Promotional Campaign: create CMA disclaimer for price promotion in prime page
        //* To be commented when the campaign is over
        // if (!$rootScope.cmaGBapplies) {

        //     $rootScope.createCMAlabels(
        //         'aps20_12_1',
        //         'Avira Prime 25',
        //         'aps20',
        //         '2023-11-23',
        //         '2023-12-03',
        //     );
        //     $rootScope.createCMAlabels(
        //         'aps10_12_1',
        //         'Avira Prime',
        //         'aps10',
        //         '2023-11-23',
        //         '2023-12-03',
        //     );

        // }


    }

    // get selected configuration price
    updateRuntime(runtime) {

        eventManager.broadcast('runtime:changed', { runtime });
        const product = this.$scope.activeProduct;
        this.$scope.runtime = runtime;
        const currentPrice = this.$scope.prices[product]
            .find(price => price.attributes.runtimes === runtime.toString());
        this.$scope.currentPrice = currentPrice;
        const discount = this.Util.deepFind(this.$scope.currentPrice, 'attributes.promotion.discount');
        this.$scope.discount = discount ? `${discount}%` : '20%';

        // lang fix for discount
        if (CWCONFIG.language === 'de') {

            this.$scope.discount = discount ? `${discount} %` : '20 %';

        }
        if (CWCONFIG.language === 'tr') {

            this.$scope.discount = discount ? `%${discount}` : '%20';

        }

    }

    // Group prices by app acronym, @param: array
    groupPrices(prices) {

        const primeLicenses = this.checkPrimeActivationCodes();
        const groupedPrices = {};
        groupedPrices.aps10 = [];
        groupedPrices.aps20 = [];
        let aps10longestRuntime = 0;
        let aps20longestRuntime = 0;

        const aps20 = primeLicenses.find(license => license.attributes.app === 'aps20');
        const aps10 = primeLicenses.find(license => license.attributes.app === 'aps10');

        primeLicenses.forEach((prime) => {

            const runtime = this.Util.deepFind(prime, 'attributes.runtime');

            if (!aps20) {

                if (prime.attributes.app.indexOf('aps10') === 0) {

                    aps10longestRuntime = runtime === 1 ? '1' : '12';

                }

            }

            if (prime.attributes.app.indexOf('aps20') === 0 && runtime > aps20longestRuntime) {

                aps20longestRuntime = runtime === 1 ? '1' : '12';

            }

        });

        prices.forEach((price) => {

            const runtime = this.Util.deepFind(price, 'attributes.runtimes');
            if (runtime < 36) {

                if (!aps20) {

                    if (price.id.indexOf('aps10') === 0 && runtime >= aps10longestRuntime) {

                        groupedPrices.aps10.push(price);

                    }

                }

                if (price.id.indexOf('aps20') === 0 && runtime >= aps20longestRuntime) {

                    groupedPrices.aps20.push(price);

                }

            }

        });

        if (aps10) {

            this.$scope.activeProduct = 'aps20';
            this.$scope.numberOfDevices = '25';

        }

        this.$scope.prices = {};
        this.$scope.prices.aps10 = groupedPrices.aps10;
        this.$scope.prices.aps20 = groupedPrices.aps20;
        this.updateRuntime(this.$scope.runtime);
        this.updateCurrentProduct(this.$scope.activeProduct, this.$scope.numberOfDevices);

        return groupedPrices;

    }

    // Returns an array with prime activation codes
    checkPrimeActivationCodes() {

        const primeArr = [];
        const actvationCodes = ActivationCodesRepository.getAll();
        actvationCodes.forEach((activationCode) => {

            const appId = this.Util.deepFind(activationCode, 'relationships.app.data.id');
            if (appId && (appId === 'aps10' || appId === 'aps20')) {

                primeArr.push(activationCode);

            }

        });

        return primeArr;

    }

    buy(appId, runtimes) {

        const currentPrice = AppPricesRepository.getSinglePrice(appId, runtimes, '1');

        let price = '';
        let discount = '';

        if (currentPrice) {

            if (this.Util.deepFind(currentPrice, 'attributes.promotion')) {

                price = this.Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                discount = this.Util.deepFind(currentPrice, 'attributes.promotion.discount');

            } else {

                price = this.Util.deepFind(currentPrice, 'attributes.price_string');
                discount = 0;

            }

        }

        const mixpanelData = {
            'Product ID': appId,
            Page: 'Prime Store Page',
            Runtimes: runtimes,
            Price: price,
            Discount: discount,
        };

        Mixpanel.send('ConnectWeb Store Buy Click', mixpanelData);

        this.$state.go('root.dashboard.store.ltb.buy', {
            ltb: 'payment-cart',
            resourceId: appId,
            subsource: 'store_prime',
            promotion: true,
            runtime: runtimes,
        }, {
            reload: false,
        });

    }

    // Scroll top when see plans button is clicked
    // Scroll down when 'find out more' is clicked
    gotoAnchor(anchor) {

        this.$location.hash(anchor);
        this.$anchorScroll();

    }

    // @param - app acronym(aps10, aps20) and number of devices: 5, 25
    updateCurrentProduct(activeProduct, numberOfDevices) {

        eventManager.broadcast('product:changed', { activeProduct });
        this.$scope.numberOfDevices = numberOfDevices;
        this.$scope.activeProduct = activeProduct;
        const appPrices = this.$scope.prices[activeProduct];
        this.$scope.currentPrice =
            appPrices.find(price => parseInt(price.attributes.runtimes, 0) >= 12);
        this.updateRuntime(this.$scope.currentPrice.attributes.runtimes);

    }

}


class PrimePageDirective {

    constructor() {

        this.template = require('./prime-page.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $scope, $rootScope, $window, Util, $location,
            $anchorScroll, AppPricesRestService, PaymentUrlsRestService, ErrorHandler,
        ) =>
            new PrimePageController(
                $scope, $rootScope, $window, Util, $location,
                $anchorScroll, AppPricesRestService, PaymentUrlsRestService, ErrorHandler,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'primePageCtrl';

    }

}

_directiveDependencies.push(() => new PrimePageDirective());


angular.module('directives')
    .directive('primePage', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/prime-page/prime-page.js